// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jO8m","fullView":"styles_fullView__2xQ06"};